<template>
  <v-row no-gutters align-content="center">
    <v-col :cols=4>
      <div
        class="text-subtitle-1 px-5"
        style="color:black;"
        :id="id">
        {{headerTitle}}
      </div>
      <v-divider class="py-2"></v-divider>
    </v-col>
    <v-col :cols=8>
      <dd-switch
        class="subtitle-1-switch-line-divider px-5 pb-4"
        :label="switchLabel"
        v-bind="computedProps"
        v-on="computedListeners"/>
      <v-divider class="py-2"></v-divider></v-col>
  </v-row>
</template>
<script>
import inputMixin from '@/mixins/inputMixins'
import DdSwitch from '@/components/DdSwitch'

/**
 * @file DDv2用スイッチ付きサブヘッダ
 * @namespace components
 */

/**
 * @vue-prop {String} [id=''] - ID
 * @vue-prop {String} [headerTitle=''] - サブヘッダータイトル
 * @vue-prop {String} [switchLabel=''] - スイッチラベル
 * @see components.DdSwitch
 * @example
 * <dd-arrow-header-with-switch
 *   v-model="checkValue"
 *   id="string"
 *   headerTitle="string"
 *   switchLabel="string"
 * />
 */
export default {
  name: 'DdSubTitleWithSwitch',
  components: {
    DdSwitch
  },
  extends: DdSwitch,
  mixins: [inputMixin],
  props: {
    /**
     * ID
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * 表示ヘッダータイトル
     */
    headerTitle: {
      type: String,
      default: ''
    },
    /**
     * スイッチのラベル
     */
    switchLabel: {
      type: String,
      default: ''
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  watch: {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
  }
}
</script>
<style scoped>
/* subtitle-1を使った見出しのスタイル調整 */
.text-subtitle-1 {
    color: #333; /*文字の色を変更*/
    padding: .1em .5em;
    margin-top: 9px;
    border-left: 1px solid rgb(47, 117, 181); /*線の色を変更*/
}
/* subtitle-1を使用したdivider上のswitchに適用するスタイル調整*/
.subtitle-1-switch-line-divider{
    margin-top:2px !important;
    padding-top:7px !important;
}
</style>
